import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../../../../../../components/loading/loading";
import { useDispatch } from "react-redux";
import { getInspectionFirmDetailsRequest } from "../../../../../../redux/inspection-firms/slice";
import { deactivateInspectionFirmRequest } from "../../../../../../utils/APICalls";

const styles = {
  container: {
    width: 500,
    maxWidth: 500,
  },
  headerTxt: {
    fontWeight: "540",
    letterSpacing: "0.6px",
    fontSize: 20,
  },
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  layout: {
    width: 452,
    mt: -2,
  },
  message: {
    color: "rgba(0, 0, 0, 0.87)",
    mb: 0.5,
  },
  subMessage: {
    color: "rgba(0, 0, 0, 0.87)",
    mb: 0.5,
    mt: 2.5,
  },
  actionBtn: {
    ml: 2,
    mr: 1,
  },
  buttonLayout: {
    mb: 0.5,
  },
  buttonTxt: {
    fontWeight: "520",
    letterSpacing: "0.5px",
    fontSize: 14,
  },
};

export default function DeactivateInspectionFirmDialog({
  showDialog,
  closeDialog,
  id,
  name,
}: any) {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const deactivateInspectionFirm = async () => {
    setLoading(true);
    const response = await deactivateInspectionFirmRequest(id);
    setLoading(false);
    if (response?.status === 204) {
      dispatch(getInspectionFirmDetailsRequest({ id }));
      closeDialog();
    }
  };

  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: styles.container }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography sx={styles.headerTxt}>
          Deactivate Inspection Firm?
        </Typography>
      </DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.layout}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.message}>
            Are you sure you want to deactivate {name}? All inspection firm
            users will also be deactivated and no longer have access to the
            system.
          </Typography>
          <Typography sx={styles.subMessage}>
            Spectrum Admins can reactivate inspection firms in the future by
            toggling to <b>Show Inactive Inspection Firms</b> from the{" "}
            <b>All Inspection Firms</b> page.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.buttonLayout}>
        <Button variant="contained" onClick={closeDialog}>
          <Typography sx={styles.buttonTxt}>Cancel</Typography>
        </Button>
        <Button
          sx={styles.actionBtn}
          onClick={deactivateInspectionFirm}
          autoFocus
        >
          <Typography sx={styles.buttonTxt}>
            Deactivate Inspection Firm
          </Typography>
        </Button>
      </DialogActions>
      {loading && <Loading />}
    </Dialog>
  );
}
